<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <el-container style="height:650px;">
      <el-container style="height:100%">
        <el-aside width="20%" height="100%">
          <el-card class="box-card" style="padding:25px;height:100%;overflow:auto;">
            <el-form :model="vacationData" :rules="rules" ref="vacationData">
              <el-row>
                <el-form-item prop="name" label="假日名称:">
                  <el-input v-model="vacationData.name" placeholder="请填写假日名称"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="放假对象:">
                  <el-radio-group v-model="vacationData.objType" @change="onRadioGroupChange">
                    <el-radio :label="0">所有员工</el-radio>
                    <el-radio :label="1">
                      <span @click="setObj">指定员工 {{vacationData.uids.length}}人</span>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="重复方式:">
                  <el-select v-model="vacationData.repeatType" placeholder="请选择">
                    <el-option
                      v-for="item in repeatTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item prop="startTime" label="开始日期:">
                  <el-date-picker
                    v-model="vacationData.startTime"
                    align="right"
                    type="datetime"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item prop="endTime" label="结束日期:">
                  <el-date-picker
                    v-model="vacationData.endTime"
                    align="right"
                    type="datetime"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item>
                  <el-checkbox v-model="vacationData.isWholeDay">全天</el-checkbox>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button size="medium" class="btn-primary" @click="editVacation">{{btnName}}</el-button>
                <el-button size="medium" class="btn-primary" v-if="isEdit" @click="delVacation">删除</el-button>
              </el-row>
            </el-form>
          </el-card>
        </el-aside>
        <el-main width="80%" height="100%" style="padding-top:0px;">
          <el-card class="box-card" style="padding:15px;height:100%;overflow:auto;">
            <el-calendar>
              <template slot="dateCell" slot-scope="{date, data}">
                <div class="calendarDayClass" @click="onCalendarClick(date)">
                  <p
                    :class="data.isSelected ? 'is-selected' : ''"
                  >{{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}</p>
                  <div :key="index" v-for="(item,index) in vacationList">
                    <el-tag
                      class="tagClass"
                      @click.stop="onVacationTagClick(item)"
                      :color="getTagColor(item)"
                      v-if="getTagVisible(item,date)"
                    >{{getTagValue(item,date)}}</el-tag>
                  </div>
                </div>
              </template>
            </el-calendar>
          </el-card>
          <el-dialog title="人员选择" :visible.sync="staff_dialogVisible" width="680px">
            <el-row style="margin:20px">
              <el-cascader
                style="width:200px"
                :options="orgSearchData"
                :props="cascaderProps"
                :show-all-levels="false"
                clearable
                @change="cascaderOnChange"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.Name }}</span>
                </template>
              </el-cascader>
              <el-transfer
                filterable
                :titles="['员工列表', '已选择员工']"
                :filter-method="transferfilter"
                filter-placeholder="请输入关键字"
                v-model="rightStaffList"
                :data="leftStaffList"
                :props="transferProps"
                @change="onTransferChange"
              >
                <span slot-scope="{ option }">{{ option.Name }}</span>
              </el-transfer>
            </el-row>
            <el-row type="flex" justify="end" style="margin:0px 35px 15px 0px;">
              <el-button class="btn-primary" size="small" @click="staff_dialogVisible=false">取消</el-button>
              <el-button class="btn-primary" size="small" @click="saveUids()">确定</el-button>
            </el-row>
          </el-dialog>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
export default {
  name: "",
  components: {
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      isEdit: false,
      btnName: "新增",
      staff_dialogVisible: false,
      entpId: userMsg.EntpId,
      permission: {},
      entpStaffsSearchData: {
        entpId: userMsg.EntpId,
        name: ""
      },
      vacationData: {
        id: "",
        entpId: userMsg.EntpId,
        name: "",
        objType: 0,
        repeatType: 0,
        startTime: "",
        endTime: "",
        isWholeDay: false,
        uids: [],
        datetime: ""
      },
      vacationList: [
        //   {
        //     "Id":"67d87e69-c30e-4b0e-a4a8-729d76270369",
        //     "EntpId":"39e3b7ac-9744-4be4-9dfc-adbb5c77308f",
        //     "Name":"五一假期",
        //     "ObjType":1,
        //     "RepeatType":0,
        //     "IsWholeDay":true,
        //     "StartTime":"2020-05-01 00:00:00",
        //     "EndTime":"2020-05-05 00:00:00",
        //     "uIds":[
        //         "365786f0-2d24-4164-9264-b709e6ba8857",
        //         "bfcf3ecf-fa94-496e-90fb-e223fa91b694"
        //     ]
        // }
      ],
      entpStaffsSelectList: [],
      orgSearchData: [],
      leftStaffList: [], //只是展示左侧列表的数据,不作上传
      orginEntpStaffList: [], //保留原始的数据,做匹配和还原
      rightStaffList: [], //只是展示右侧列表的数据,不作上传
      // uploadStaffList: [], //最终上传的数组
      transferProps: {
        key: "Id",
        label: "Name",
        action: "action"
      },
      cascaderProps: {
        emitPath: false,
        expandTrigger: "hover",
        children: "Childrens",
        label: "Name",
        value: "Id",
        key: "CascadeId",
        checkStrictly: true
      },
      tempCascadeId: "",
      transferfilter(query, item) {
        return item.Name.indexOf(query) > -1;
      },
      repeatTypes: [
        {
          value: 0,
          label: "指定方式"
        },
        {
          value: 1,
          label: "每月同一时间"
        },
        {
          value: 2,
          label: "每年同一时间"
        }
      ],
      rules: {
        name: [{ required: true, message: "请输入假期名称", trigger: "blur" }],
        startTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ]
      },
      getTagVisible(item, date) {
        let stTime = new Date(item.StartTime);
        let edTime = new Date(item.EndTime);
        let currentCellday = new Date(date);
        currentCellday.setHours(0);
        currentCellday.setMinutes(0);
        if (currentCellday >= stTime && currentCellday <= edTime) {
          return true;
        } else {
          return false;
        }
      },
      getTagValue(item, date) {
        let stTime = new Date(item.StartTime);
        let edTime = new Date(item.EndTime);
        let currentCellday = new Date(date);
        currentCellday.setHours(0);
        currentCellday.setMinutes(0);
        if (currentCellday >= stTime && currentCellday <= edTime) {
          return item.Name;
        } else {
          return "";
        }
      },
      getTagColor(item) {
        let color = "";
        switch (item.RepeatType) {
          case 0:
            color = "#409EFF";
            break;
          case 1:
            color = "#67C23A";
            break;
          case 2:
            color = "#E6A23C";
            break;
        }

        return color;
      }
    };
  },
  created() {
    this.getVacationList();
  },
  mounted() {},
  methods: {
    //点击指定员工
    setObj() {
      this.staff_dialogVisible = true;
      this.getOrgTree();
      this.getStaffsSelectList();
    },
    //放假对象
    onRadioGroupChange(val) {
      switch (val) {
        case 0:
          this.staff_dialogVisible = false;
          break;
      }
    },
    //日历点击事件
    onCalendarClick(data) {
      this.isEdit = false;
      this.btnName = "新增";
      let sTime = new Date(data);
      this.vacationData = {
        id: "",
        entpId: this.entpId,
        name: "",
        objType: 0,
        repeatType: 0,
        startTime: sTime,
        endTime: "",
        isWholeDay: false,
        uids: []
      };
    },
    //假期点击事件
    onVacationTagClick(item) {
      this.isEdit = true;
      this.btnName = "保存";
      let sTime = new Date(item.StartTime);
      let eTime = new Date(item.EndTime);
      this.vacationData = {
        id: item.Id,
        entpId: item.EntpId,
        name: item.Name,
        objType: item.ObjType,
        repeatType: item.RepeatType,
        startTime: sTime,
        endTime: eTime,
        isWholeDay: item.IsWholeDay,
        uids: item.uIds
      };
    },
    saveUids() {
      this.vacationData.uids = this.rightStaffList;
      this.staff_dialogVisible = false;
    },
    //新增/更新假期
    editVacation() {
      this.$util
        .axiosPost({
          url: "/api/AttendanceSystem/editVacation",
          data: this.vacationData
        })
        .then(res => {
          if (res.errcode == 0) {
            this.$util.successMsg("更新成功");
            this.getVacationList();
          }
        })
        .catch(err => {});
    },
    //删除假期
    delVacation() {
      let id = this.vacationData.id;
      this.$util
        .axiosPost({
          url: "/api/AttendanceSystem/DelVacation?id=" + id
        })
        .then(res => {
          if (res.errcode == 0) {
            this.$util.successMsg("删除成功");
            this.getVacationList();
          }
        })
        .catch(err => {});
    },
    //获取假期列表
    getVacationList() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetVacationList",
          data: this.entpStaffsSearchData
        })
        .then(res => {
          if (res.data) {
            this.vacationList = res.data;
          }
        })
        .catch(err => {});
    },
    //获取企业员工列表
    getStaffsSelectList() {
      let that = this;
      that.leftStaffList = [];
      that.orginEntpStaffList = [];
      that.rightStaffList = [];
      that.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetEntpStaffsSelectList",
          data: this.entpStaffsSearchData
        })
        .then(res => {
          if (res.data) {
            that.staff_dialogVisible = true;
            that.leftStaffList = res.data;
            that.orginEntpStaffList = res.data;
            let count = that.vacationData.uids.length;
            for (let j = 0; j < that.vacationData.uids.length; j++) {
              const vd = that.vacationData.uids[j];
              for (let index = 0; index < that.leftStaffList.length; index++) {
                const element = that.leftStaffList[index];
                if (element.Id == vd) {
                  that.rightStaffList.push(element.Id);
                  count--;
                  if (count <= 0) {
                    index = that.leftStaffList.length;
                  }
                }
              }
            }
          }
        })
        .catch(err => {});
    },
    //获取企业部门列表
    getOrgTree() {
      this.$util
        .axiosGet({
          url: "/api/EntpInfoManagement/GetOrgTree",
        })
        .then(res => {
          if (res.data) {
            this.orgSearchData = this.getTreeData(res.data);
          }
        })
        .catch(err => {});
    },
    // 数列
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].Childrens.length < 1) {
          data[i].Childrens = undefined;
        } else {
          this.getTreeData(data[i].Childrens);
        }
      }
      return data;
    },
    onTransferChange(list, direction, moveValue) {
      this.rightStaffList = list;
    },
    //通过部门筛选员工
    cascaderOnChange(value) {
      this.tempCascadeId = "";
      if (value != null) {
        this.searchOrgCascadeId(value, this.orgSearchData[0].Childrens);
        let tempList = [];
        this.leftStaffList = this.orginEntpStaffList;
        for (let index = 0; index < this.leftStaffList.length; index++) {
          const element = this.leftStaffList[index];
          if (element.CascadeId.indexOf(this.tempCascadeId) > -1) {
            tempList.push(element);
          }
        }
        this.leftStaffList = tempList;
      } else {
        this.leftStaffList = this.orginEntpStaffList;
      }
    },
    //递归所有部门,通过Id匹配CascadeId
    searchOrgCascadeId(key, data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (key == element.Id) {
          this.tempCascadeId = element.CascadeId;
        } else {
          if (element.Childrens.length > 0) {
            this.searchOrgCascadeId(key, element.Childrens);
          }
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.tagClass {
  width: 100%;
  height: 20px;
  line-height: 20px;
  position: relative;
  margin: 0px;
  color: #ffffff;
}
.calendarDayClass {
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 1000;
}
</style>
